import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Container, Overline } from "@/lib/ui";
import { PAGE } from "@/constants/testIds";

export const PageHero = ({ id, overline, title, lead, image }) => (
  <section data-testid={PAGE.hero(id)} className="relative pt-[72px] bg-[#121A16] text-white overflow-hidden">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-35" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121A16] via-[#121A16]/70 to-[#121A16]/50" />
      </div>
    )}
    <Container className="relative py-24 md:py-32">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <Overline dark>{overline}</Overline>
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 font-display font-light text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl"
      >
        {title}
      </motion.h1>
      {lead && (
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-7 max-w-2xl text-white/65 text-lg leading-relaxed">
          {lead}
        </motion.p>
      )}
    </Container>
  </section>
);

export const CTABand = () => (
  <section className="py-20 md:py-28 bg-[#1B3B2B] grain-dark text-white relative overflow-hidden">
    <Container className="relative text-center flex flex-col items-center">
      <h2 className="font-display font-light text-3xl md:text-5xl leading-tight tracking-tight max-w-3xl">
        Ready to hold your assets to a higher operating standard?
      </h2>
      <Link to="/contact" className="mt-9 inline-flex items-center gap-2.5 rounded-sm bg-white text-[#1B3B2B] px-8 py-4 text-sm font-medium hover:bg-[#E8E2D9] transition-colors">
        Request a Proposal
      </Link>
    </Container>
  </section>
);
